define('../common/js/xPageId',['require','exports','module','./libs/getBase58Id'],function(require, exports, module) {
    'use strict';

    var getBase58Id = require('./libs/getBase58Id');

    var xPageId = getBase58Id(8);

    try {
        console.log('x-page-id: ' + xPageId);
    } catch (reason) {
    }

    module.exports = xPageId;
});

